export default __webpack_public_path__ + "static/media/service-live-logo.556b9d94.jpg";